"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDriverUser = void 0;
/**
 * Allows you to create a new driver-user. n.b. You must send the Cognito drivers pool `userPoolId` and `clientId` in the header.

 */
var postDriverUser = function (instance) {
    return function (body, config) {
        return instance.post("/users/driver", body, config);
    };
};
exports.postDriverUser = postDriverUser;
